<template>
  <button v-if="value"
    type="button"
    class="btn lg inverse success"
    @click="value=0">
    <i class="icon state-success"><Icon :name="icons[0]" /></i>
    <span>{{ words[0] | trans }}</span>
  </button>
  <button v-else
    type="button"
    class="btn lg inverse error"
    @click="value=1">
    <i class="icon state-error"><Icon :name="icons[1]" /></i>
    <span>{{ words[1] | trans }}</span>
  </button>
</template>

<script>
  import {abstractField} from "vue-form-generator";
  
  export default {
    name: 'field-boolean',
    mixins: [abstractField],
    computed: {
      type () {
        if (this.schema.inputType) {
          return this.schema.inputType;
        }
        return 'yesno';
      },
      words () {
        switch (this.type) {
          case 'visibility':
            return ['active', 'inactive'];
          case 'yesno':
          default:
            return ['yes', 'no'];
        }
      },
      icons () {
        switch (this.type) {
          case 'visibility':
            return ['visible', 'invisible'];
          case 'yesno':
          default:
            return ['tick', 'close'];
        }
      },
    }
  }
</script>

<style lang="scss">
  div.form-group.field-boolean {
    display: flex;
    justify-content: space-between;
    align-items: center;
    button.btn span {
      color: $default-color !important;
    }
    button.btn.error {
      border-color: $state-error;
    }
    button.btn.success {
      border-color: $state-success;
    }
  }
</style>



// WEBPACK FOOTER //
// src/helpers/mixins/form/Boolean.vue